const CUSTOM_AUTH0_ERRORS = Object.freeze({
  invalid_request: 'invalid_request',
  no_role: 'no_role',
  no_accounts: 'no_accounts',
  access_denied: 'access_denied',
  incorrect_login_method: 'incorrect_login_method',
  no_user_in_shard: 'no_user_in_shard',
  no_such_user: 'no_such_user',
  login_required: 'login_required'
});

export default CUSTOM_AUTH0_ERRORS;
